import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { AppButton, AppCard, Reveal } from '@/components/atoms';
import { Section } from '@/components/organisms';

import { galleryBridge } from '../content';

/** A persistent route from destination information to the separate proof archive. */
export function DeliveryGalleryBridge() {
  return (
    <Section>
      <Reveal>
        <AppCard
          sx={{
            p: { xs: 5, md: 8 },
            borderRadius: 3,
            backgroundImage:
              'linear-gradient(125deg, rgba(173, 22, 32, 0.08), transparent 58%)',
          }}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 5, md: 8 }}
            alignItems={{ md: 'center' }}
            justifyContent="space-between"
          >
            <Stack spacing={2} sx={{ maxWidth: '68ch' }}>
              <Typography variant="overline" color="primary.main">
                {galleryBridge.eyebrow}
              </Typography>
              <Typography variant="h3" component="h2">
                {galleryBridge.title}
              </Typography>
              <Typography color="text.secondary">{galleryBridge.lede}</Typography>
            </Stack>
            <AppButton to="/deliveries/gallery" appVariant="secondary" sx={{ flexShrink: 0 }}>
              {galleryBridge.action}
            </AppButton>
          </Stack>
        </AppCard>
      </Reveal>
    </Section>
  );
}
